import { DialogProps } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import { LocalModal } from '@/components';
import { selectActiveModal, uiActions } from '@/store';

export const AppModal = ({
  children,
  modalName,
  onClose,
  hidePaper,
  transparentBackground,
  disableBackdropClick,
  ...muiDialogProps
}: {
  children: React.ReactNode;
  modalName: string;
  disableBackdropClick?: boolean;
  hidePaper?: boolean;
  transparentBackground?: boolean;
  onClose?: () => void;
} & Omit<DialogProps, 'onClose' | 'open'>) => {
  const dispatch = useDispatch();
  const activeModal = useSelector(selectActiveModal);
  const modalParams = activeModal?.params;
  const isOpen = activeModal?.name === modalName;

  const onAppModalClose = () => {
    onClose?.();
    dispatch(uiActions.closeActiveModal());
  };

  return (
    <LocalModal
      name={modalName}
      open={isOpen}
      onClose={onAppModalClose}
      disableBackdropClick={disableBackdropClick}
      hidePaper={hidePaper}
      transparentBackground={transparentBackground}
      location={modalParams?.referrer}
      {...muiDialogProps}>
      {children}
    </LocalModal>
  );
};
